
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqBE2unMZ0vWhnNnv05E5c0Ri78_rhRxpBdPQrUDWaUl4Meta } from "/codebuild/output/src4010120838/src/src/pages/faq.vue?macro=true";
import { default as menuq8d1pwD07T_45IpD0aeJ9HUL8hAfC_453PvwECimogPmPlEMeta } from "/codebuild/output/src4010120838/src/src/pages/menu.vue?macro=true";
import { default as indexRnKLPcFCm4bPcxeSgZuhACCL_F5CAmk57wb9tvoZtQcMeta } from "/codebuild/output/src4010120838/src/src/pages/index.vue?macro=true";
import { default as contact6IKH1pc7Vfi08W5ki2cPo_pmll_5xRCdNuStqaDHvmsMeta } from "/codebuild/output/src4010120838/src/src/pages/contact.vue?macro=true";
import { default as tutorialmvLgXmllCYj96EhczFcJyE422nrpiPoCzX05mfup9p0Meta } from "/codebuild/output/src4010120838/src/src/pages/tutorial.vue?macro=true";
import { default as agreementynuIXP0Mcb3k7E_e_XdrSv7EeX2hat0t8_IB8ng_IDkMeta } from "/codebuild/output/src4010120838/src/src/pages/agreement.vue?macro=true";
import { default as about_45passRroG5dvNfJOnlrROq_djkvYQIvFv1hYDukReTrn4rEEMeta } from "/codebuild/output/src4010120838/src/src/pages/about-pass.vue?macro=true";
import { default as indexO91vuFkTHCpFC6VDbu3FhCJqKvXn9p7j0KH888Qtc7IMeta } from "/codebuild/output/src4010120838/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93G14eBqA_syiiRNOerxNmaHsxnlmJFV_nshUnrzis4TIMeta } from "/codebuild/output/src4010120838/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceKOMosZ2u9hrTXfBlihCX9m5z0QGs15PoHRU0JWc5lm8Meta } from "/codebuild/output/src4010120838/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93pba9cAIZFnjUp_45BNZOh7PKrmXlS_45bTnuKWs_QUjVQNMMeta } from "/codebuild/output/src4010120838/src/src/pages/notice/[id].vue?macro=true";
import { default as indexdiQXR9vXbguiB98UAjJfAhu5O0u3Ht5TQP70MZEkWaEMeta } from "/codebuild/output/src4010120838/src/src/pages/coupon/index.vue?macro=true";
import { default as indexUeVVUhR5sQXVzTONU42xLLbsvjEZKj5stjUwkiocCxUMeta } from "/codebuild/output/src4010120838/src/src/pages/mypage/index.vue?macro=true";
import { default as indexp2iX94OBeM0_453Tu_y69bt_58hHksdjkV2Fp07F3YVWYMeta } from "/codebuild/output/src4010120838/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93Q9v3Xz_1R5XttBDKPmEFkjfnw4bn9UJpKVcUi3CCcvwMeta } from "/codebuild/output/src4010120838/src/src/pages/parking/[id].vue?macro=true";
import { default as index8oOu7cPgwF36LsqFf7oBCuN6Ksz6tVD6UVve1p5RNasMeta } from "/codebuild/output/src4010120838/src/src/pages/history/index.vue?macro=true";
import { default as indexox2otxyGbujFONnRw_45vUh9eouc_xxgj_45HkHw81Rq8BsMeta } from "/codebuild/output/src4010120838/src/src/pages/monthly/index.vue?macro=true";
import { default as indexkwetQ9wG3LwCGg3cb1bJVtWzcznkklC9JjmrZyVrhWYMeta } from "/codebuild/output/src4010120838/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexs5Bheix7AsUGYDgUVGycfU1UHhNnMwj0_OkSwVKb0UQMeta } from "/codebuild/output/src4010120838/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviwNZDi3R5W6fbYGnexwCY_45XyJBFFstm49GQp4c7_oJyoMeta } from "/codebuild/output/src4010120838/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editI_cv74FTjrv1hwJyzZo_qx3sG5ZZh9P_45p1LjSl_45n3FYMeta } from "/codebuild/output/src4010120838/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementAYkXU5RTrU6u7r6Zf5uA0c7SqIoZY33qwNLQZZnNsp0Meta } from "/codebuild/output/src4010120838/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexIKQFByh_45ltH9wtCGcQLeYFBtpizMras9bLaHBwNZtQIMeta } from "/codebuild/output/src4010120838/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453d0UiRm1Ruh6VI6BTZGhgAEddAqIcmHUwFoeY_bHzkr_45gMeta } from "/codebuild/output/src4010120838/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmL83gKLX5NRZXi0t1IRLaE_lrUT8z0TcmQ1Rfj7hU6PwMeta } from "/codebuild/output/src4010120838/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexUMQCaCSpI2E9Ruw6nJPtK_45CE7EMvNXbNj3INDt2fK2sMeta } from "/codebuild/output/src4010120838/src/src/pages/card/create/index.vue?macro=true";
import { default as indexEyzjolfHPVBcV8G2tKwY_cOCUJ8aC3lrPw79ssVzFN8Meta } from "/codebuild/output/src4010120838/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmE9jzRoMQGXi9S1cw7z_45f3lgcCF5s4TuSnM_11RY7fXgMeta } from "/codebuild/output/src4010120838/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmfMZa5bI1or0IXgyzdct_yzSBpMNlTjZCEBOTqhAw7zgMeta } from "/codebuild/output/src4010120838/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeiy0XwADKqTlIutR016TOy5nAF4QMwBXcC_Lb2RIfqFEMeta } from "/codebuild/output/src4010120838/src/src/pages/membership/complete.vue?macro=true";
import { default as registerHWOWpzG6bsBscG12hXUXXWMVkSd7dORPP_tYpwuGk3AMeta } from "/codebuild/output/src4010120838/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_933ttZaflj7i0sdftsgKy9B3bP9jDi_45J2erS6sOh4IFk4Meta } from "/codebuild/output/src4010120838/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmwvAO4tKE0SLmyfpiOD20lTnjME2dk_45tQKsWWreR8Gy4Meta } from "/codebuild/output/src4010120838/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93NY_htptP4JeF13jvsIOCguNJUUwIvoUcfOnJnD3xwSUMeta } from "/codebuild/output/src4010120838/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexOUNtUsK1UZMlzPB6zbV_45WVapel_hBXZEEO21R8syPggMeta } from "/codebuild/output/src4010120838/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeFi5EHyHSyWpu4P52kBi3HEtBRSDckH3kMc9ROjcU8bgMeta } from "/codebuild/output/src4010120838/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeTMV64p6BwZzmjzPuCSjN5qqEhHJWdAboQXlwbPwx9VgMeta } from "/codebuild/output/src4010120838/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeUdjd9OZafB99B36OkBRdBGR2DsjZ0IaCgN2U0p2NAR8Meta } from "/codebuild/output/src4010120838/src/src/pages/contact-form/complete.vue?macro=true";
import { default as register2seG1vbwonDsJYGDL88AgUcLOcwf6eDTClfID6FLon4Meta } from "/codebuild/output/src4010120838/src/src/pages/contact-form/register.vue?macro=true";
import { default as completek4jYzQGB24pKqbN_45ELRosnSnyuKfbctlFtrr7EuWNXIMeta } from "/codebuild/output/src4010120838/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexkS1asqSbj1Eatx_iX9YX5W3DjjLDSJ8I_45kJPEQpSYe0Meta } from "/codebuild/output/src4010120838/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmGd1xAqguw2TYpiAe4PpoCKMbgHTNfx3kO90ZSMf_45DE4Meta } from "/codebuild/output/src4010120838/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete_4521MxI_45s_qHZcOFQMteM5W_8L5Yl8ZDMX6RpCExk0OUMeta } from "/codebuild/output/src4010120838/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexlkiPzMd_Ns6__J1YfpNthO82nttdfPomg64OvQBD8yUMeta } from "/codebuild/output/src4010120838/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93NgBtwqPBeYrrAPDZOjwuvkP_45hdEPoqr8dB8_19EJxc0Meta } from "/codebuild/output/src4010120838/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeqedvW3heppq_4fPU9XYb08k4Y2ibgwFLfogO1QzAKcIMeta } from "/codebuild/output/src4010120838/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasr6nJeWOIJQvB7gX_TE5yYEethfpaspY1K0HfE_45R_45_uEMeta } from "/codebuild/output/src4010120838/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleTR2h3Xe6BHhIAsnl6jZAXVhDg4Flwmr2TsTgXZkvJpAMeta } from "/codebuild/output/src4010120838/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45email56QpSQ2ZI1DMXwXwlf2_qa9tku8YI_45gXDZ_nOQehnH4Meta } from "/codebuild/output/src4010120838/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmk2Q291IgtfHoaUcsZc_45td5EOBCbYU5_16Zh7LoJbh90Meta } from "/codebuild/output/src4010120838/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consent0m3_TtVO3L_I1KiklwzwLvUkUxPzHW3jocOiDWIOMoAMeta } from "/codebuild/output/src4010120838/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirm2u_45IAElpoZR7e5ywAjoXZcYv63OYk00acfN8_AwMPdgMeta } from "/codebuild/output/src4010120838/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatesBqnLuJIRXSMfo0vF8GxpTaDLSOxC0YFgCsvD5D7suYMeta } from "/codebuild/output/src4010120838/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeYW0epOzjdveVDwCZT4zNSdd1WAReRycX6gD_LkTGbj0Meta } from "/codebuild/output/src4010120838/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codelfGdytaGlCX2XcpvsI3sC70GUMKjmec01zZJQ9bgsMIMeta } from "/codebuild/output/src4010120838/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordDluO9fxX8IJsUOKEgIoHcb8qMqV_7RPegB9IiuUIxSsMeta } from "/codebuild/output/src4010120838/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliastvMKIrwWfl_45QsdEBSSqg6VLlI4JOIXROVX_45FoFbfIscMeta } from "/codebuild/output/src4010120838/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registeryMAN9fWLFOdxmWMA8j8Ziyotku7f_0HTTLhd8pr58pwMeta } from "/codebuild/output/src4010120838/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeJFmPvwc9gfwRbTeULyTj4YaQu7rs6Fxt3_RWZxC9LxcMeta } from "/codebuild/output/src4010120838/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexdmDe_oMFVZOleBNPu_45RqVt5wEvVbUwmelpebCBMYn3YMeta } from "/codebuild/output/src4010120838/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexaV2FpgFwc8hB42F7o3Xzd8ZegO9mtJOgyG7gQbkKWp8Meta } from "/codebuild/output/src4010120838/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index5_45cF5Bqz6xgz3k7_45mXPBDjF_45syDspGqKDiBumWUsTKoMeta } from "/codebuild/output/src4010120838/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexkkSOtVdVxfmxevw4hUuGnCOir7vEsOVroIERvWENUtYMeta } from "/codebuild/output/src4010120838/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatelQvARqfxUxyWl9ps_45pHPmwI_45ynzI0AfJSDumYLkuaeAMeta } from "/codebuild/output/src4010120838/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeBIxq42AXGMBuFLItzDQsatkhzCHddtkGACJYfBANUx4Meta } from "/codebuild/output/src4010120838/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmy7oUfb6mJihEiYl_45yl_45piO2PNxoMg8sMs7R4S1FkNwoMeta } from "/codebuild/output/src4010120838/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexzDJqHA0wGNnpwHaqaxW0dofLEwzKduQ8P6Kw_3OomuoMeta } from "/codebuild/output/src4010120838/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete99wvp8PrZawDGQYDH5VzyfOWwTE1OcEC7a2QakSzZRoMeta } from "/codebuild/output/src4010120838/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateeXOVK8epZaDwpr4IS69Ow5JURLEQPEbUdpZ2E44_45rfgMeta } from "/codebuild/output/src4010120838/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexdUEr61uPi_WKe7_45Eorj1CeelDgqs9wXcVg33TgfNGlYMeta } from "/codebuild/output/src4010120838/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexzg3LRNORXMw3LfNBSvU3Suk8J5Zu0_45jgE7VQJA5HxvEMeta } from "/codebuild/output/src4010120838/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeWKPLzGdK35av9q22niVSIQfhdpfCPgZo3gH7to2INHEMeta } from "/codebuild/output/src4010120838/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as index_45Rz6T_452MyWSufwLVsBTj3JqQDo3ij_xRPN_Rhqp3vlYMeta } from "/codebuild/output/src4010120838/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeO_45S03jHyHj1tXuB005m1O2Jr9ckWUIsUdYzW2ayg38wMeta } from "/codebuild/output/src4010120838/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexHn_45HKKlLF6by4GvQyZDiUDMhep0tEkvlKuIhWvcTpQIMeta } from "/codebuild/output/src4010120838/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexMwaFwN871mX3Of7IVij72kZObiSeoMiypfcX_YlRE6EMeta } from "/codebuild/output/src4010120838/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexflqEo6txuzM2pPmK0SHi45UlmSj8W7X9ZCCIuFBd0wQMeta } from "/codebuild/output/src4010120838/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updategQ5CTwAThUQ76fkFtIENECRMbLFFBGbmE8zms929amkMeta } from "/codebuild/output/src4010120838/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmGxQyR0m49S89rC4hKb9nop3fwfM5BN5qzY1UM1D4jTkMeta } from "/codebuild/output/src4010120838/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuq8d1pwD07T_45IpD0aeJ9HUL8hAfC_453PvwECimogPmPlEMeta || {},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexRnKLPcFCm4bPcxeSgZuhACCL_F5CAmk57wb9tvoZtQcMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src4010120838/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexdiQXR9vXbguiB98UAjJfAhu5O0u3Ht5TQP70MZEkWaEMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src4010120838/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index8oOu7cPgwF36LsqFf7oBCuN6Ksz6tVD6UVve1p5RNasMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src4010120838/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexkwetQ9wG3LwCGg3cb1bJVtWzcznkklC9JjmrZyVrhWYMeta || {},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexs5Bheix7AsUGYDgUVGycfU1UHhNnMwj0_OkSwVKb0UQMeta || {},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexUMQCaCSpI2E9Ruw6nJPtK_45CE7EMvNXbNj3INDt2fK2sMeta || {},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmE9jzRoMQGXi9S1cw7z_45f3lgcCF5s4TuSnM_11RY7fXgMeta || {},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmfMZa5bI1or0IXgyzdct_yzSBpMNlTjZCEBOTqhAw7zgMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src4010120838/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeiy0XwADKqTlIutR016TOy5nAF4QMwBXcC_Lb2RIfqFEMeta || {},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerHWOWpzG6bsBscG12hXUXXWMVkSd7dORPP_tYpwuGk3AMeta || {},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmwvAO4tKE0SLmyfpiOD20lTnjME2dk_45tQKsWWreR8Gy4Meta || {},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeFi5EHyHSyWpu4P52kBi3HEtBRSDckH3kMc9ROjcU8bgMeta || {},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeTMV64p6BwZzmjzPuCSjN5qqEhHJWdAboQXlwbPwx9VgMeta || {},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeUdjd9OZafB99B36OkBRdBGR2DsjZ0IaCgN2U0p2NAR8Meta || {},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: register2seG1vbwonDsJYGDL88AgUcLOcwf6eDTClfID6FLon4Meta || {},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmGd1xAqguw2TYpiAe4PpoCKMbgHTNfx3kO90ZSMf_45DE4Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src4010120838/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete_4521MxI_45s_qHZcOFQMteM5W_8L5Yl8ZDMX6RpCExk0OUMeta || {},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexlkiPzMd_Ns6__J1YfpNthO82nttdfPomg64OvQBD8yUMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src4010120838/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeqedvW3heppq_4fPU9XYb08k4Y2ibgwFLfogO1QzAKcIMeta || {},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleTR2h3Xe6BHhIAsnl6jZAXVhDg4Flwmr2TsTgXZkvJpAMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src4010120838/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45email56QpSQ2ZI1DMXwXwlf2_qa9tku8YI_45gXDZ_nOQehnH4Meta || {},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmk2Q291IgtfHoaUcsZc_45td5EOBCbYU5_16Zh7LoJbh90Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4010120838/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consent0m3_TtVO3L_I1KiklwzwLvUkUxPzHW3jocOiDWIOMoAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4010120838/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirm2u_45IAElpoZR7e5ywAjoXZcYv63OYk00acfN8_AwMPdgMeta || {},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeYW0epOzjdveVDwCZT4zNSdd1WAReRycX6gD_LkTGbj0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4010120838/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codelfGdytaGlCX2XcpvsI3sC70GUMKjmec01zZJQ9bgsMIMeta || {},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordDluO9fxX8IJsUOKEgIoHcb8qMqV_7RPegB9IiuUIxSsMeta || {},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registeryMAN9fWLFOdxmWMA8j8Ziyotku7f_0HTTLhd8pr58pwMeta || {},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeJFmPvwc9gfwRbTeULyTj4YaQu7rs6Fxt3_RWZxC9LxcMeta || {},
    component: () => import("/codebuild/output/src4010120838/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src4010120838/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]